import { render, staticRenderFns } from "./RptEtiquetasCustom.vue?vue&type=template&id=656be539&scoped=true&"
import script from "./RptEtiquetasCustom.vue?vue&type=script&lang=js&"
export * from "./RptEtiquetasCustom.vue?vue&type=script&lang=js&"
import style0 from "./RptEtiquetasCustom.vue?vue&type=style&index=0&id=656be539&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "656be539",
  null
  
)

export default component.exports